import SectionContent from "./SectionContent";
import useWindowSize from "@hooks/useWindowSize";
import { usePageContext } from "@providers/PageProvider";
import { discoverPage } from "@utils/helper";
import _ from "lodash";

const View = () => {
  const { width = 1280 } = useWindowSize();
  const isMobile = width! <= 576;
  const { pageData } = usePageContext();
  const intro = discoverPage.formatIntroduce(pageData);
  return (
    <SectionContent
      type="left"
      className={isMobile ? "no-padding-top" : ""}
      content={_.get(intro, "content")}
      title={_.get(intro, "title")}
      image={_.get(intro, "image")}
      border="none"
    />
  );
};
export default View;
